/* 🤖 this file was generated by svg-to-ts */
export const matIconPhonelinkErase: {
  name: 'phonelink-erase';
  data: string;
} = {
  name: 'phonelink-erase',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m13 8.2-1-1-4 4-4-4-1 1 4 4-4 4 1 1 4-4 4 4 1-1-4-4 4-4zM19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z"/></svg>`
};
